/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FixedWingCalendarResponse } from '../../models/fixed-wing-calendar-response';

export interface GetFixedWingCalendar$Params {
  dateFrom: string;
  dateTo: string;
}

export function getFixedWingCalendar(http: HttpClient, rootUrl: string, params: GetFixedWingCalendar$Params, context?: HttpContext): Observable<StrictHttpResponse<FixedWingCalendarResponse>> {
  const rb = new RequestBuilder(rootUrl, getFixedWingCalendar.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FixedWingCalendarResponse>;
    })
  );
}

getFixedWingCalendar.PATH = '/api/scheduler/daily-line-schedule/fixed-wing/calendar';
